import { Text } from '@chakra-ui/react'

export const ModalTitle = ({ title }: { title: string }) => {
  return <Text fontSize="2xl">{title}</Text>
}
